export default class DataSource {
  constructor(server, method, config = {}){
    this.draw = 0;
    this.pendingDraw = 0;
    this.result = [];
    this.dummy = [];
    this.filter = config.filter || {};
    this.activeFilter = {};
    this.limit = config.limit || 10;
    this.order = config.order || null;
    this.offset = config.offset || 0;
    this.activeOffset = 0;
    this.totalResults = 0;
    this.filteredResults = 0;
    this.working = false;
    this.server = server;
    this.method = method;
    this.error = null;
    this.hasError = false;
  }

  setFilter(filter){
    this.filter = filter;
    return this;
  }

  setOrder(order){
    this.order = order;
    return this;
  }

  load(){
    const draw = ++this.pendingDraw;
    this.working = true;
    this.hasError = false;
    var activeOffset = this.offset;
    var activeFilter = Object.assign({}, this.filter);
    return this.server(this.method, {
      filter: this.filter,
      order: this.order,
      limit: this.limit,
      offset: this.offset
    }).then(data => {
      if(draw == this.pendingDraw){
        this.draw = draw;
        this._load(data.result);
        this.activeFilter = activeFilter;
        this.activeOffset = activeOffset;
        this.totalResults = data.totalResults;
        this.filteredResults = data.filteredResults;
        this.working = false;
        this.dummy = [];
        for(var i=this.result.length; i < this.limit; i++){
          this.dummy.push(i);
        }
      }
      return this.result;
    }, err => {
      this.hasError = true;
      this.error = err;
    });
  }

  wait(){
    return this.load().then(() => this);
  }

  _load(result){
    this.result = result;
  }

  push(item){
    this.result.push(item);
  }

  getError(){
    return this.hasError && this.error;
  }

  hasFailed(){
    return this.hasError;
  }

  isWorking(){
    return this.busy;
  }


}


// WEBPACK FOOTER //
// ./src/DataSource/DataSource.js